// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = require("!!../../../../node_modules/css-loader/index.js?minimize!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-36c71ba2\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../node_modules/sass-loader/dist/cjs.js!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./BudgetInvoiceScanSnapshot.vue");
if(typeof content === 'string') content = [[module.id, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = require("!../../../../node_modules/vue-loader/node_modules/vue-style-loader/lib/addStylesClient.js")("31380478", content, true, {});


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/node_modules/vue-style-loader!./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-36c71ba2","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/dist/cjs.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/_modules/I2P/BudgetInvoiceScanSnapshot.vue
// module id = AsvT
// module chunks = 12